/** 工单状态 */
export enum DemandOrderStatusEnum {
  PENDING = 'pending',
  DOING = 'doing',
  REFUSED = 'rejected',
  COMPLETED = 'completed',
  REVOKED = 'revoked',
}

export enum TradeStatus {
  UNPAID = 'unpaid',
  PAID = 'paid',
  FAIL = 'fail',
}
